<template>
  <div>
    <a-card :bordered="false">
      <a-row class="article-wrapper" type="flex" justify="space-between">
        <a-col :span="24" :xs="24" :sm="24" :md="6" :lg="6" :xl="6">
          <a-menu
            mode="inline"
            :defaultSelectedKeys="[0]"
            :style="{
              width: '250px',
              height: 'auto',
              borderRight: 0,
              overflowY: 'auto',
              overflowX: 'hidden',
            }"
            @openChange="onOpenChange"
          >
            <a-menu-item
              v-for="(article, i) in articleList"
              :key="i"
              @click="currentArticle = article"
            >
              <a-icon type="right" />
              {{ article.cmsTitile }}
            </a-menu-item>

            <a-menu-item v-if="category == 8" @click="commentVisible = true">
              <a-icon type="right" />在线留言
            </a-menu-item>
          </a-menu>
        </a-col>
        <a-col :span="24" :xs="24" :sm="24" :md="18" :lg="18" :xl="18">
          <div
            class="article-content"
            v-if="currentArticle"
            v-html="currentArticle.cmsContent"
          ></div>
        </a-col>
      </a-row>
    </a-card>
    <a-modal
      :visible="commentVisible"
      :maskClosable="false"
      title="在线留言"
      :destroyOnClose="true"
      @cancel="commentVisible = false"
      @ok="comment"
    >
      <a-form>
        <a-form-item label="姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-input
            v-model="commentInfo.realname"
            placeholder="请输入姓名"
          ></a-input>
        </a-form-item>
        <a-form-item
          label="手机号"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-input
            v-model="commentInfo.phone"
            placeholder="请输入手机号"
          ></a-input>
        </a-form-item>
        <a-form-item label="留言" :labelCol="labelCol" :wrapperCol="wrapperCol">
          <a-textarea
            :auto-size="{ minRows: 5, maxRows: 10 }"
            v-model="commentInfo.comment"
            placeholder="请输入留言内容"
          ></a-textarea>
        </a-form-item>
      </a-form>
    </a-modal>
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import store from "@/store";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Banner from "../components/Banner";
import { getCmsList } from "@/api/article";
import { getAction, postAction } from "@/api/manage";
import { mixinDevice } from "@/utils/mixin.js";

export default {
  mixins: [mixinDevice],
  components: {
    Banner,
    Header,
    Footer,
  },
  data() {
    return {
      id: "",
      category: "",
      articleList: [],
      currentArticle: {},
      commentSuccess: false,
      commentVisible: false,
      commentInfo: {
        realname: "",
        phone: "",
        comment: "",
      },
      labelCol: {
        xs: { span: 24 },
        sm: { span: 5 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
      tenantConfig: {},
    };
  },
  created() {
    this.tenantConfig = Vue.ls.get(TENANT_CONFIG);
    this.category = this.$route.query.category;
    if (this.category) {
      this.getCmsList(this.category);
    }
    this.id = this.$route.query.id;
    if (this.id) {
      this.getCmsList(this.id);
    }
  },
  mounted() {},
  watch: {
    $route(to, from) {
      this.category = this.$route.query.category;
      this.getCmsList(this.category);
    },
  },
  mounted() {},
  methods: {
    getCmsList(category) {
      getCmsList(category, 1, 999).then((res) => {
        if (res.success) {
          this.articleList = res.result.records;
          if (res.result.total > 0) {
            if (!this.id) {
              this.currentArticle = this.articleList[0];
            }
          } else {
            this.currentArticle.content = "暂无文章";
          }
        }
      });
    },
    // getArticleDetail(){
    //   getArticleDetail(this.id).then(res=>{
    //     this.currentArticle = res.result
    //   })
    // },
    selectArticle(article) {},
    comment() {
      console.log(this.commentInfo);
      if (this.commentSuccess) {
        this.$message.info("已经留言过了");
        return;
      }
      if (!this.commentInfo.realname || !this.commentInfo.phone) {
        this.$message.info("请填写完整");
        return;
      }
      postAction("/teaching/teachingAppointment/add", this.commentInfo).then(
        (res) => {
          if (res.success) {
            this.$message.success("留言成功");
            this.commentSuccess = true;
            this.commentVisible = false;
          }
        }
      );
    },
    onOpenChange(openKeys) {
      const rootSubmenuKeys = this.courseUnits.map((item) => {
        return item.id;
      });
      const latestOpenKey = openKeys.find(
        (key) => this.openKeys.indexOf(key) === -1
      );
      if (rootSubmenuKeys.indexOf(latestOpenKey) === -1) {
        this.openKeys = openKeys;
      } else {
        this.openKeys = latestOpenKey ? [latestOpenKey] : [];
      }
    },
  },
};
</script>

<style lang="less" scoped>
.article-wrapper {
  min-height: 80vh;
  margin: 30px auto;
}
.article-content {
  overflow: auto;
  padding: 20px;
  // height: 80vh;
  background: #fff;
  /deep/img {
    max-width: 100%;
    height: auto;
  }
}
</style>